<div fxLayout="row"
     fxLayoutAlign="space-between" style="margin-bottom: 10px">
  <mat-icon class="scale-3quarter close"
            (click)="dialogRef.close()">
    close
  </mat-icon>
</div>

<form #form='ngForm' (ngSubmit)="submit()"
      fxLayout="row"
      fxLayoutAlign="space-between start">
  <mat-form-field style="width: 250px">
    <mat-label [class.form-error]="email.errors?.['required']">メールアドレス</mat-label>
    <input matInput
           type="email"
           name="email"
           placeholder="メールアドレス"
           id="inputEmail"
           #email="ngModel"
           [(ngModel)]="mail"
           autocomplete="username email"
           required>
  </mat-form-field>
  <button mat-raised-button
          color="primary"
          (click)="submit()"
          [disabled]="invalidEmail()">
    送信
  </button>
</form>
